export default __webpack_public_path__ + "static/media/state-1.8f0a3044.svg";